import { Col, Row } from 'reactstrap';
import DealsMap from './components/DealsMap';
import DataPanel from './components/DataPanel';
import { Deal } from '../types';
import { useBatchGeocodedDeals } from '../hooks/useBatchGeocodedDeals';
import './MapView.scss';

interface IMapViewProps {
    deals: Deal[];
    selectedDeal: Deal | null;
    hoveredDealId: number | null;
    onSelectDeal: (deal: Deal) => void;
    onDeselectDeal: () => void;
    onHoverDeal: (dealId: number | null) => void;
}

const MapView = ({
    deals,
    selectedDeal,
    hoveredDealId,
    onSelectDeal,
    onDeselectDeal,
    onHoverDeal,
}: IMapViewProps) => {
    const geocodedCoordinates = useBatchGeocodedDeals(deals);

    return (
        <Row className="MapView pt-2 px-2 pb-0 flex-nowrap">
            <Col xs={selectedDeal ? 8 : 12} className="MapView__map-col d-block p-0">
                <DealsMap
                    deals={deals}
                    geocodedCoordinates={geocodedCoordinates}
                    selectedDealId={selectedDeal?.id ?? null}
                    hoveredDealId={hoveredDealId}
                    onSelectDeal={onSelectDeal}
                    onDeselectDeal={onDeselectDeal}
                    onHoverDeal={onHoverDeal}
                />
            </Col>
            {selectedDeal && (
                <Col xs={4} className="MapView__panel-col p-0">
                    <DataPanel detail={selectedDeal} onClose={onDeselectDeal} />
                </Col>
            )}
        </Row>
    );
};

export default MapView;
